import { creditCardConstants } from '../constants'

const initialState = {
	creditCards: [],
	safeBoxCreditCards: []
}

export default function creditCardsReducer(state = initialState, action) {
	switch (action.type) {
		case creditCardConstants.GET_CARDS:
			return { creditCards: action.payload }

		case creditCardConstants.GET_ALL_CARDS:
			return { safeBoxCreditCards: action.payload }

		default:
			return state
	}
}
